<template>
  <v-navigation-drawer
    app
    permanent
    clipped
    ref="drawer"
    :width="navigation.width"
    v-model="navigation.shown"
  >
    <v-expansion-panels  v-model="panel" multiple>
      <v-expansion-panel>
        <v-expansion-panel-header>
          {{ $t('NAVI_SEARCHES_TITLE') }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <TreeviewPeople v-if="true"/>
          <div class="text-xs-center" v-else>
            <v-progress-circular indeterminate></v-progress-circular>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>
          {{ $t('NAVI_MAILINGS_TITLE') }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div slot="header"></div>
          <TreeviewCampaigns v-if="true"/>
          <div class="text-xs-center" v-else>
            <v-progress-circular indeterminate></v-progress-circular>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex'

import TreeviewPeople from './TreeviewPeople'
import TreeviewCampaigns from './TreeviewCampaigns'

export default {
  name: 'Sidebar',
  components: {
    TreeviewPeople,
    TreeviewCampaigns
  },
  props: [],
  data() {
    return {
      panel: [0,1],
      navigation: {
        shown: false,
        width: 300,
        borderSize: 6,
        color:'rgba(51,153,0,.25)'
      }
    }
  },
  computed: {
    ...mapGetters([
      'isBusy'
    ]),
    direction() {
      return this.navigation.shown === false ? "Open" : "Closed";
    }
  },
  mounted() {
    this.setBorderWidth();
    this.setEvents();
  },
  methods: {
    setBorderWidth() {
      // let i = this.$refs.drawer.$el.querySelector(
      //   ".v-navigation-drawer__border"
      // );
      // i.style.width = this.navigation.borderSize + "px";
      // i.style.cursor = "ew-resize";
      // i.style.backgroundColor = this.navigation.color;

      // i = this.$refs.drawer.$el.querySelector(
      //   ".v-navigation-drawer__content"
      // );
      // i.style.marginRight = this.navigation.borderSize + "px";
    },
    setEvents() {
      const minSize = this.navigation.borderSize;
      const el = this.$refs.drawer.$el;
      const drawerBorder = el.querySelector(".v-navigation-drawer__border");

      // const vm = this;
      const direction = el.classList.contains("v-navigation-drawer--right")
        ? "right"
        : "left";

      function resize(e) {
        document.body.style.cursor = "ew-resize";
        let f =
          direction === "right"
            ? document.body.scrollWidth - e.clientX
            : e.clientX;
        el.style.width = f + "px";
      }

      drawerBorder.addEventListener(
        "mousedown",
        (e) => {
          if (e.offsetX < minSize) {
            el.style.transition = "initial";
            document.addEventListener("mousemove", resize, false);
          }
        },
        false
      );

      document.addEventListener(
        "mouseup",
        () => {
          el.style.transition = "";
          this.navigation.width = el.style.width;
          document.body.style.cursor = "";
          document.removeEventListener("mousemove", resize, false);
        },
        false
      );
    }
  },
}
</script>

<style lang="scss">
.theme--light.v-treeview .v-treeview-node {
  // cursor: default;
}
.theme--light.v-treeview .v-treeview-node--active {
  // background: none;
}
.theme--light.v-treeview .v-treeview-node--active > .v-treeview-node__root {
  // background: rgba(0,0,0,.12);
}

.v-treeview-node__root {
  padding-right: 0;
}

.v-navigation-drawer__border {
  width: 6px;
  cursor: ew-resize;
  background-color: rgba(51,153,0,.25);
}

.v-navigation-drawer__border {
  cursor: ew-resize;
  background-color: rgba(51,153,0,.25) !important;
  width: 6px!important;
  border: 2px dotted darkgrey;
}

.v-navigation-drawer__content {
  margin-right: 6px;
}

</style>

<style scoped lang="scss">
.v-navigation-drawer {
  z-index: 3;
}
// reset Expansion Panel styles so we can have dynamic Sidebar width
.v-expansion-panel {
  display: block;
}
.v-progress-circular {
  margin: 1rem;
}
</style>
